<template>
    <v-card>
        <v-toolbar class="elevation-1">
        <v-toolbar-title>  
            Course Weightings
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
            append-icon="search"
            label="Search"
            flat
            v-model="search"
            solo
        ></v-text-field>
        </v-toolbar>
        <v-data-table
        :headers="headers"
        :items="items"
        item-key="id"
        :pagination.sync="pagination"
        :total-items="totalItems"
        :loading="loading"
        :rows-per-page-items="rowsPerPageItems"
        class="elevation-1">
            <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <!-- <td>{{ props.item.weighting }}</td>  -->
            <td class="text-xs-right">
                <v-edit-dialog
                    :return-value.sync="props.item.weighting"
                    large
                    lazy
                    persistent
                    @save="saveWeighting(props.item.id, props.item.weighting)"
                    
                >
                    <div>{{ props.item.weighting }}</div>
                    <div slot="input" class="mt-3 title">Update Weighting</div>
                    <v-text-field
                    slot="input"
                    v-model="props.item.weighting"
                    label="Edit"
                    single-line
                    autofocus
                    ></v-text-field> 
                    
                </v-edit-dialog>
            </td>
            <td>
             <v-edit-dialog
                    :return-value.sync="props.item.weighting"
                    large
                    lazy
                    persistent
                    @save="saveWeighting(props.item.id, props.item.weighting)"
                    
                >
                    <!-- <v-icon small>edit</v-icon> -->
                    <v-btn fab dark small color="grey" outline><v-icon dark small>edit</v-icon>
                    </v-btn>  
                    <div slot="input" class="mt-3 title">Update Weighting</div>
                    <v-text-field
                    slot="input"
                    v-model="props.item.weighting"
                    label="Edit"
                    single-line
                    autofocus
                    ></v-text-field> 
                    
                </v-edit-dialog>
            </td>
            </template>
        </v-data-table>    
    </v-card>
</template>

<script>
import { globalStore } from '../main';
import { getListByPeriod, updateCourseWeighting } from '../utils/effort-tracking-api';

 export default {
    data () {
      return {
        search: '',
        totalItems: 0,
        loading: false,
        rowsPerPageItems: globalStore.rowsPerPageItems ,
        pagination: { sortBy: 'name', rowsPerPage: globalStore.defaultRowsPerPage },
        headers: [
          { text: 'Name', value: 'name' },
          { text: 'Weighting', value: 'weighting' },
          { text: 'Actions', value: '' }
        ],
        items: []
      }
    },
    watch: {
      search: {
        handler () {
           this.debouncedGetDataFromApi()
        },
      },
      pagination: {
        handler () {
            this.debouncedGetDataFromApi()
        },
        deep: true
      }
    },
    mounted () {
      this.debouncedGetDataFromApi = _.debounce(this.getDataFromApi, 500, { trailing:true })
    },
    methods: {
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      getDataFromApi () {
        this.loading = true;
        getListByPeriod("courses", this.pagination, this.search).then(data => {
            console.log(data);
            this.items = data.items
            this.totalItems = data.count
            this.loading = false;
        })
      },
      saveWeighting(id, weighting) {
          updateCourseWeighting(id, weighting).then(result => {
              console.log(result);
          }).catch(ex => console.log(ex));
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Courses.vue